import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { SEO } from "../components/SEO";
import { CTAPair } from "../components/CTA";
import { Reveal } from "../components/Motion";
import { getGuide, GUIDES } from "../data/guides";
import NotFound from "./NotFound";

const GuideDetail = () => {
  const { guideSlug } = useParams();
  const guide = getGuide(guideSlug);
  if (!guide) return <NotFound />;
  const others = GUIDES.filter((g) => g.slug !== guide.slug);

  return (
    <main data-testid="guide-detail-page">
      <SEO title={guide.meta.title} description={guide.meta.description} />
      <article className="bg-paper grain relative">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 pt-14 pb-16 md:pt-20">
          <Reveal>
            <Link to="/resources" data-testid="guide-back" className="inline-flex items-center gap-2 text-sm font-bold text-rust hover:text-rust-dark transition-colors mb-8">
              <ArrowLeft size={16} aria-hidden /> All guides
            </Link>
            <p className="font-mono text-xs uppercase tracking-[0.22em] text-steel font-semibold mb-4">Guide</p>
            <h1 className="font-display font-black tracking-tight leading-[1.08] text-3xl sm:text-4xl lg:text-5xl" data-testid="guide-title">{guide.title}</h1>
            <p className="mt-5 text-lg text-smoke leading-relaxed">{guide.excerpt}</p>
          </Reveal>
          <div className="mt-10 space-y-10" data-testid="guide-body">
            {guide.sections.map((s) => (
              <Reveal key={s.h}>
                <section>
                  <h2 className="font-display font-extrabold tracking-tight text-xl sm:text-2xl mb-3">{s.h}</h2>
                  <p className="text-smoke leading-relaxed">{s.body}</p>
                </section>
              </Reveal>
            ))}
          </div>
          <div className="mt-14 bg-charcoal text-cream p-7 sm:p-9">
            <h2 className="font-display font-black tracking-tight text-2xl" data-testid="guide-cta-heading">Ready when you are</h2>
            <p className="mt-2 text-cream/70 text-[15px]">Two photos, one straight price, repaired on-site.</p>
            <div className="mt-5"><CTAPair dark compact testidPrefix="guide-cta" /></div>
          </div>
          <div className="mt-10 flex flex-wrap gap-3">
            {others.map((g) => (
              <Link key={g.slug} to={`/resources/${g.slug}`} data-testid={`guide-next-${g.slug}`} className="btn-cut border-2 border-ink/60 px-4 py-2 text-sm font-bold hover:bg-charcoal hover:text-cream hover:border-charcoal transition-colors">
                {g.title}
              </Link>
            ))}
          </div>
        </div>
      </article>
    </main>
  );
};

export default GuideDetail;
